/* eslint-disable */
import TermPage from '../../../components/pages/termPage'

const Cookie = ({ className }) => {
   return (
      <TermPage className={className} currentKey="cookie" />
   )
}
export default Cookie